import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { AndonBoardTextLayoutItem } from "~/features/andon/andon.types";

import { computeTextLabelFontSizePx } from "~/features/andon/andonBoard/andonBoardTextLabel.utils";

type AndonBoardTextLabelProps = {
  textLayoutItem: AndonBoardTextLayoutItem;
  boardScale?: number;
};

export function AndonBoardTextLabel({
  textLayoutItem,
  boardScale = 1
}: AndonBoardTextLabelProps) {
  const fontSizePx = computeTextLabelFontSizePx(
    textLayoutItem.fontSize,
    boardScale
  );

  return (
    <Tooltip title={textLayoutItem.text}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor:
            textLayoutItem.backgroundColor || "rgba(0, 0, 0, 0.7)",
          borderRadius: "4px",
          border: "2px solid",
          borderColor: "rgba(255, 255, 255, 0.3)",
          padding: "4px",
          boxSizing: "border-box",
          overflow: "hidden",
          cursor: "pointer",
          userSelect: "none"
        }}
      >
        <Typography
          component="span"
          sx={{
            color: textLayoutItem.textColor || "white",
            fontSize: `${fontSizePx}px`,
            fontWeight: "bold",
            textAlign: "center",
            wordBreak: "break-word",
            lineHeight: 1.2,
            userSelect: "none",
            cursor: "inherit",
            width: "100%"
          }}
        >
          {textLayoutItem.text}
        </Typography>
      </Box>
    </Tooltip>
  );
}

export default AndonBoardTextLabel;
